import React, { Component } from 'react';
import { Icon, notification, Spin, Upload } from 'antd';

import './IPointsSyncPage.scss';

const Dragger = Upload.Dragger;

const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');

export default class IPointsSyncPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        }
    }

    handleFileChange(info) {
        this.setState({ isLoading: true });

        const status = info.file.status;
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            this.setState({ isLoading: false });

            notification.success({
                message: 'Synced Succeed',
                description: `Successfully synced with ${info.file.name}.`
            });
        } else if (status === 'error') {
            this.setState({ isLoading: false });

            notification.error({
                message: 'Synced Failed',
                description: `Failed to sync with ${info.file.name}.`
            });
        }
    }

    render() {
        const { isLoading } = this.state;

        return (
            <Spin spinning={isLoading}>
	            <div className="IPointsSyncPage ListPage">
	            	<div className="page-header">
	            		<h2>i-Points Sync</h2>
	            	</div>
					<Dragger 
						name="file"
						accept=".csv"
						showUploadList={false}
						headers={{ Authorization: `bearer ${jwt()}` }}
						action={`${API_URL}/sync/ipoints`}
						onChange={(info) => this.handleFileChange(info)}
					>
						<p className="ant-upload-drag-icon">
							<Icon type="file" />
						</p>
						<p className="ant-upload-text">Click or drag csv file to this area to upload</p>
	    				<p className="ant-upload-hint">Support CSV only. Please make sure the file's header contains <b>email</b>, <b>contact_number</b>, <b>ipoints</b> only.</p>
					</Dragger>
	            </div>
            </Spin>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/IPointsSyncPage/IPointsSyncPage.js